import * as queries from "../../graphql/queries";
import * as nongenedQueries from "../../queries/nongenedQueries";
import * as mutations from "../../graphql/mutations";
import {
  Sponsor,
  ProgramSponsors,
  ListProgramSponsorsQuery,
  ModelProgramSponsorsConnection,
  DeleteProgramSponsorsMutation,
  CreateProgramSponsorsInput,
  CreateProgramSponsorsMutation,
  GetSponsorQueryVariables,
  GetSponsorQuery
} from "../../API";
import {
  genericQuery,
  listQueryAutoPaginated,
  fetchAllWithPagination
} from "../api/apiUtils";

// Migrated from AppSync (listSponsors) to the REST /api/sponsors endpoint
// (sponsors-list Lambda), mirroring fetchAllNetworks.
export const fetchAllSponsors = async (): Promise<Sponsor[] | null> => {
  return await fetchAllWithPagination<Sponsor>("sponsors", "sponsors", 500);
};

export async function fetchProgramSponsorsByProgramId(programId: string) {
  const predicate = { filter: { programID: { eq: programId } } };
  return await listQueryAutoPaginated<
    ListProgramSponsorsQuery,
    ProgramSponsors,
    ModelProgramSponsorsConnection
  >(queries.listProgramSponsors, "listProgramSponsors", "items", predicate);
}

export async function deleteProgramSponsor(id: string) {
  const predicate = { input: { id: id } };
  return await genericQuery<DeleteProgramSponsorsMutation, ProgramSponsors>(
    mutations.deleteProgramSponsors,
    "deleteProgramSponsors",
    predicate
  );
}

export async function createProgramSponsor(input: CreateProgramSponsorsInput) {
  const predicate = { input: input };
  return await genericQuery<CreateProgramSponsorsMutation, ProgramSponsors>(
    mutations.createProgramSponsors,
    "createProgramSponsors",
    predicate
  );
}

export const fetchSponsor = async (sponsorId: string) => {
  const variables: GetSponsorQueryVariables = {
    id: sponsorId
  };
  return await genericQuery<GetSponsorQuery, Sponsor>(
    nongenedQueries.getSponsorWithoutPrograms,
    "getSponsor",
    variables
  );
};
